import axios from '../../axios';

export default async function DeleteCardRequest(
  cardId: number
): Promise<any> {
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/payment/cards`,
    {
      params: { cardId }, 
    }
  );

  return response.data;
}